import PlayerModel from './PlayerModel'

export default (user) => {
  if (!user) return

  if (user.player) {
    user.player = PlayerModel(user.player)
  }

  return Object.defineProperties(user, {})
}



// WEBPACK FOOTER //
// ./src/services/Models/UserModel.js